import Big from "big.js"

/**
 * @typedef {import('../../js-doc').UiClientModel} UiClientModel
 * @typedef {import('../../js-doc').V2ClientResponse} V2ClientResponse
 * @typedef {import('../../js-doc').V2ClientFactoringStatus} V2ClientFactoringStatus
 * @typedef {import('../../js-doc').V1ClientStatus} V1ClientStatus
 */

/**
 * @param {V2ClientFactoringStatus=} v2Status - V2 status
 * @returns {V1ClientStatus}
 */
const mapClientStatus = (v2Status) => {
  switch (v2Status) {
    case 'hold':
      return 'on hold'
    case 'onboarding':
      return 'pending'
    case 'active':
      return 'active'
    case 'released':
      return 'released'

    default:
      return 'pending'
  }
}

/**
 *
 * @param {V2ClientResponse} client - V2 Client
 * @returns {UiClientModel}
 */
export const mapV2ClientToUiClient = (client) => {
  return {
    ...client,
    status: mapClientStatus(client.factoringConfig.status),
    factor_rate_percentage: new Big(client.factoringConfig.factoringRatePercentage),
    reserve_rate_percentage: new Big(client.factoringConfig.reserveRatePercentage),
    client_limit: client.factoringConfig.clientLimit ? new Big(client.factoringConfig.clientLimit) : null,
    is_active: client.commonAuthorityStatus === 'Active' && client.insuranceStatus === 'Active',
    shortened_name: client.shortName,
    vip_status: client.factoringConfig.vip,
    requires_verification: client.factoringConfig.requiresVerification,
    cc_in_emails: client.factoringConfig.ccInEmails,
    expedite_flag: client.factoringConfig.expediteTransferOnly,
    done_submitting_invoices_flag: client.factoringConfig.doneSubmittingInvoices,
  }
}
